// extracted by mini-css-extract-plugin
export var chevronIcon = "_8i-2";
export var teamName = "_8i-1";
export var teamSwitcherButton = "_8i-0";